"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classnames = _interopRequireDefault(require("classnames"));

var _underscore = require("underscore");

var _FormLabel = _interopRequireDefault(require("../FormLabel"));

var _FormError = _interopRequireDefault(require("../FormError"));

var _Button = _interopRequireDefault(require("../../buttons/Button"));

var _KeyboardUtils = require("../../../util/KeyboardUtils");

var _PropUtils = require("../../../util/PropUtils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @name FileUploadStateless
 * @memberof FileUpload
 * @desc This is a wrapper around the stateless (stateless=true) FileUpload.
 */
var _default = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(_default, _Component);

  var _super = _createSuper(_default);

  function _default() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_clickFileInput", function (e) {
      e.stopPropagation();

      _this.refs.fileInput.click();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetComponent", function () {
      _reactDom.default.findDOMNode(_this.refs.fileInput).value = "";
    });
    return _this;
  }

  (0, _createClass2.default)(_default, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          defaultImage = _this$props.defaultImage,
          thumbnailSrc = _this$props.thumbnailSrc;
      var fileSelected = !!(thumbnailSrc || this.props.fileName);
      var containerClass = (0, _classnames.default)(this.props.className, "input-file-upload", {
        "image-upload": this.props.showThumbnail,
        "file-selected": fileSelected,
        disabled: this.props.disabled,
        "form-error": !!this.props.errorMessage
      });
      var useDefault = defaultImage && !thumbnailSrc;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: containerClass,
        "data-id": this.props["data-id"]
      }, /*#__PURE__*/_react.default.createElement("input", {
        disabled: this.props.disabled,
        type: "file",
        ref: "fileInput",
        name: this.props.name || this.props.fileName,
        accept: this.props.accept,
        onChange: this.props.onChange,
        "data-id": this.props["data-id"] + "-input"
      }), /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
        className: (0, _classnames.default)({
          "form-error": this.props.errorMessage
        }),
        value: this.props.labelText || this.props.label,
        description: this.props.description
      }, /*#__PURE__*/_react.default.createElement(ImagePreview, {
        disabled: this.props.disabled,
        isDefault: useDefault,
        onClick: this._clickFileInput,
        show: this.props.showThumbnail,
        src: useDefault ? defaultImage : thumbnailSrc
      }), /*#__PURE__*/_react.default.createElement(FileRestrictions, {
        show: this.props.showThumbnail,
        "data-id": this.props["data-id"] + "-restrictions",
        labelMaxFileSize: this.props.labelMaxFileSize,
        labelAcceptedFileTypes: this.props.labelAcceptedFileTypes
      }), !this.props.showThumbnail && /*#__PURE__*/_react.default.createElement(_Button.default, {
        "data-id": "upload-button",
        disabled: this.props.disabled,
        inline: true,
        className: (0, _classnames.default)("choose", {
          "input-file-upload__select-btn--required": this.props.required
        }),
        onClick: this._clickFileInput
      }, fileSelected && this.props.labelSelectOther || this.props.labelSelect), this.props.errorMessage && /*#__PURE__*/_react.default.createElement(_FormError.default.Icon, {
        "data-id": this.props["data-id"] + "-errormessage-icon"
      }), this.props.errorMessage && /*#__PURE__*/_react.default.createElement(_FormError.default.Message, {
        value: this.props.errorMessage,
        "data-id": this.props["data-id"] + "-errormessage"
      })), fileSelected && !this.props.disabled && /*#__PURE__*/_react.default.createElement("div", {
        className: "file-info"
      }, /*#__PURE__*/_react.default.createElement(Filename, {
        show: this.props.showFilename,
        "data-id": this.props["data-id"] + "-fileName",
        value: this.props.fileName
      }), /*#__PURE__*/_react.default.createElement("a", {
        className: "file-remove",
        "data-id": "file-remove",
        ref: "remove",
        onClick: this.props.onRemove
      }, this.props.labelRemove)), /*#__PURE__*/_react.default.createElement(AcceptMessage, {
        "data-id": this.props["data-id"] + "-filesAcceptedMessage",
        label: this.props.filesAcceptedMessage
      }));
    }
  }]);
  return _default;
}(_react.Component);

exports.default = _default;
(0, _defineProperty2.default)(_default, "displayName", "FileUploadStateless");
(0, _defineProperty2.default)(_default, "propTypes", {
  //labels
  labelText: _propTypes.default.string,
  label: _propTypes.default.node,
  labelSelect: _propTypes.default.string,
  labelSelectOther: _propTypes.default.string,
  labelRemove: _propTypes.default.string,
  labelMaxFileSize: _propTypes.default.string,
  description: _propTypes.default.node,
  //callbacks
  onRemove: _propTypes.default.func.isRequired,
  onChange: _propTypes.default.func.isRequired,
  //flags
  disabled: _propTypes.default.bool,
  showFilename: _propTypes.default.bool,
  showThumbnail: _propTypes.default.bool,
  showRemoveButton: _propTypes.default.bool,
  //properties
  defaultImage: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  errorMessage: _propTypes.default.node,
  filesAcceptedMessage: _propTypes.default.string,
  fileName: _propTypes.default.string,
  name: _propTypes.default.string,
  accept: _propTypes.default.string,
  "data-id": _propTypes.default.string,
  thumbnailSrc: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  required: _propTypes.default.bool
});
var ImagePreview = (0, _KeyboardUtils.withFocusOutline)(function (_ref) {
  var disabled = _ref.disabled,
      isDefault = _ref.isDefault,
      onClick = _ref.onClick,
      src = _ref.src,
      show = _ref.show;
  var isNode = !(0, _underscore.isString)(src);
  return show ? /*#__PURE__*/_react.default.createElement("div", null, !isDefault && /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    onClick: onClick
  }, (0, _PropUtils.getClickableA11yProps)(onClick), {
    className: (0, _classnames.default)("image-icon", {
      "image-icon--disabled": disabled
    })
  })), /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    className: (0, _classnames.default)("input-image-thumb", isDefault ? "input-image-thumb--default" : ""),
    "data-id": "image-preview",
    onClick: onClick
  }, (0, _PropUtils.getClickableA11yProps)(onClick)), isNode ? src : /*#__PURE__*/_react.default.createElement("img", {
    className: (0, _classnames.default)("input-image-thumb__img", {
      "input-image-thumb__img--disabled": disabled
    }),
    src: src,
    "data-id": "imageThumb",
    alt: "Thumbnail"
  }))) : null;
});

function FileRestrictions(_ref2) {
  var dataId = _ref2["data-id"],
      labelAcceptedFileTypes = _ref2.labelAcceptedFileTypes,
      labelMaxFileSize = _ref2.labelMaxFileSize,
      show = _ref2.show;
  return show ? /*#__PURE__*/_react.default.createElement("span", {
    className: "file-size"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "max-size",
    "data-id": dataId + "-max-size"
  }, labelMaxFileSize), /*#__PURE__*/_react.default.createElement("span", {
    className: "accepted-types",
    "data-id": dataId + "-accepted-types"
  }, labelAcceptedFileTypes)) : null;
}

function AcceptMessage(_ref3) {
  var dataId = _ref3["data-id"],
      value = _ref3.value;
  return value ? /*#__PURE__*/_react.default.createElement("div", {
    className: "image-types",
    "data-id": dataId
  }, value) : null;
}

function Filename(_ref4) {
  var dataId = _ref4["data-id"],
      show = _ref4.show,
      value = _ref4.value;
  return show ? /*#__PURE__*/_react.default.createElement("span", {
    className: "file-name",
    "data-id": dataId
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-file"
  }), value) : null;
}

module.exports = exports["default"];